const ApplicationDependencyMapping = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="10" fill="#437EF7" fill-opacity="0.25" />
    <path
      d="M18.9992 20.7H15.9992C14.4992 20.7 13.2992 19.5 13.1992 18V16C13.1992 14.5 14.3992 13.3 15.8992 13.2H18.8992C20.3992 13.2 21.5992 14.3999 21.6992 15.8999V17.8999C21.6992 19.4999 20.4992 20.7 18.9992 20.7ZM15.9992 14.7C15.2992 14.7 14.7992 15.3 14.7992 16V18C14.7992 18.7 15.3992 19.2 16.0992 19.2H19.0992C19.7992 19.2 20.2992 18.5999 20.3992 17.8999V15.8999C20.3992 15.1999 19.7992 14.7 19.0992 14.7H15.9992Z"
      fill="#437EF7"
    />
    <path
      d="M32.7992 19.7H29.1992C28.0992 19.7 27.1992 18.8 27.1992 17.7V16.1C27.1992 15 28.0992 14.1 29.1992 14.1H32.7992C33.8992 14.1 34.6992 15 34.6992 16.1V17.7C34.6992 18.9 33.8992 19.7 32.7992 19.7ZM29.1992 15.7C28.9992 15.7 28.6992 15.9 28.6992 16.2V17.8C28.6992 18 28.8992 18.3 29.1992 18.3H32.7992C32.9992 18.3 33.1992 18.1 33.1992 17.8V16.2C33.1992 16 32.9992 15.7 32.7992 15.7H29.1992Z"
      fill="#437EF7"
    />
    <path
      d="M32.7992 27.2H29.1992C28.0992 27.2 27.1992 26.3 27.1992 25.2V23.6C27.1992 22.5 28.0992 21.6 29.1992 21.6H32.7992C33.8992 21.6 34.6992 22.5 34.6992 23.6V25.2C34.6992 26.4 33.8992 27.2 32.7992 27.2ZM29.1992 23.2C28.9992 23.2 28.6992 23.4 28.6992 23.7V25.3C28.6992 25.5 28.8992 25.8 29.1992 25.8H32.7992C32.9992 25.8 33.1992 25.6 33.1992 25.3V23.7C33.1992 23.5 32.9992 23.2 32.7992 23.2H29.1992Z"
      fill="#437EF7"
    />
    <path
      d="M27.9992 17.7H20.9992C20.5992 17.7 20.1992 17.4 20.1992 16.9C20.1992 16.4 20.4992 16.1 20.9992 16.1H27.9992C28.3992 16.1 28.7992 16.4 28.7992 16.9C28.7992 17.4 28.3992 17.7 27.9992 17.7Z"
      fill="#437EF7"
    />
    <path
      d="M27.9992 32.7H26.4992C24.9992 32.7 23.7992 31.5 23.6992 30V17C23.6992 16.6 23.9992 16.2 24.4992 16.2C24.9992 16.2 25.2992 16.5 25.2992 17V30C25.2992 30.7 25.8992 31.2 26.5992 31.2H28.0992C28.4992 31.2 28.8992 31.5 28.8992 32C28.8992 32.5 28.3992 32.7 27.9992 32.7Z"
      fill="#437EF7"
    />
    <path
      d="M27.9992 25.2H24.4992C24.0992 25.2 23.6992 24.9 23.6992 24.4C23.6992 23.9 23.9992 23.6 24.4992 23.6H27.9992C28.3992 23.6 28.7992 23.9 28.7992 24.4C28.7992 24.9 28.3992 25.2 27.9992 25.2Z"
      fill="#437EF7"
    />
    <path
      d="M32.7992 34.7H29.1992C28.0992 34.7 27.1992 33.8 27.1992 32.7V31.1C27.1992 30 28.0992 29.1 29.1992 29.1H32.7992C33.8992 29.1 34.6992 30 34.6992 31.1V32.7C34.6992 33.9 33.8992 34.7 32.7992 34.7ZM29.1992 30.7C28.9992 30.7 28.6992 30.9 28.6992 31.2V32.8C28.6992 33 28.8992 33.3 29.1992 33.3H32.7992C32.9992 33.3 33.1992 33.1 33.1992 32.8V31.2C33.1992 31 32.9992 30.7 32.7992 30.7H29.1992Z"
      fill="#437EF7"
    />
  </svg>
);
export default ApplicationDependencyMapping;
